export default __webpack_public_path__ + "static/media/PricingAnalysisTool.8d8b5116.png";